import produce, { Draft } from 'immer';
import { findIndex, some } from 'lodash';

export const findIndexById = <TElement extends { id: string }>(array: Array<TElement>, id: string) => {
  return findIndex(array, element => element.id === id);
};

export const moveElement = <TElement>(
  sourceArray: Array<TElement>,
  destinationArray: Array<TElement>,
  indexInSourceArray: number,
  indexInDestinationArray: number,
) => {
  let newSourceArray: Array<TElement>;
  let newDestinationArray: Array<TElement>;

  if (sourceArray === destinationArray) {
    newSourceArray = produce(sourceArray, draft => {
      const [elementToMove] = draft.splice(indexInSourceArray, 1);
      draft.splice(indexInDestinationArray, 0, elementToMove);
    });

    newDestinationArray = newSourceArray;
  } else {
    const itemToMove = sourceArray[indexInSourceArray];

    newSourceArray = produce(sourceArray, draft => {
      draft.splice(indexInSourceArray, 1);
    });

    newDestinationArray = produce(destinationArray, draft => {
      draft.splice(indexInDestinationArray, 0, itemToMove as Draft<TElement>);
    });
  }

  return [newSourceArray, newDestinationArray];
};

export const someValueIsNull = (values: Array<unknown>) => some(values, value => value == null);

export const assertArrayHasLength = (array: Array<unknown>, length: number) => {
  if (!(array.length === length)) {
    throw new Error(`Array given has the wrong number of elements. Expected ${length} but got ${array.length}`);
  }
};
